// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"00faae2d","538":"835917fc","566":"a9afc7cc","569":"c4d2228a","614":"084c75c7","676":"29d3564b","730":"7943af5d","923":"0a914160","978":"72a4a859"}[chunkId] + ".chunk.js";
};